import { Language } from '../types/language';

interface WatchTranslation {
    header: {
        title: string;
        mainTitle: string;
    };
    firstSection: {
        title: string;
        description: string;
    };
    models: {
        singular: string;
        plural: string;
    };
    variations: string;
    specs: {
        mechanicalMovement: string;
        quartzMovement: string;
        diameter: string;
        depth: string;
        waterproofness: string;
        watchGlass: string;
        material: string;
    };
}

interface WatchPageTranslations {
    [key: string]: {
        [Language.EN]: WatchTranslation;
        [Language.DE]: WatchTranslation;
    };
}

export const watchPageTranslations: WatchPageTranslations = {
    lucidity: {
        [Language.EN]: {
            header: {
                title: 'LUCIDITY',
                mainTitle: 'THE BEAUTY OF THE ESSENTIAL',
            },
            firstSection: {
                title: 'Lucidity',
                description: 'The joy to simply be. To live - not to be lived. Strength in the simplicity, strength in the focus, the power to be what we are.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Lucidity',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
            },
        },
        [Language.DE]: {
            header: {
                title: 'LUCIDITY',
                mainTitle: 'DER AUSDRUCK DES WESENTLICHEN',
            },
            firstSection: {
                title: 'Lucidity',
                description: 'Die Freude, einfach zu sein. Zu leben - nicht gelebt zu werden. Die Kraft der Einfachheit, die Bedeutung des Fokussierens, die Macht zu sein, was wir sind.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen der Lucidity',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
            },
        },
    },
    introsistence: {
        [Language.EN]: {
            header: {
                title: 'INTROSISTENCE',
                mainTitle: 'THE INNER DEPTH',
            },
            firstSection: {
                title: 'Introsistence',
                description: 'The circle, symbol of the totality. Strength from within. The one who lives within is not hit by the storm outside. Detachment is the master of independence.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Introsistence',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
            },
        },
        [Language.DE]: {
            header: {
                title: 'INTROSISTENCE',
                mainTitle: 'DIE INNERE TIEFE',
            },
            firstSection: {
                title: 'Introsistence',
                description: 'Der Kreis, Symbol für die Gesamtheit. Die Kraft von innen. Wer im Inneren lebt, wird von den Stürmen des Äußeren nicht berührt. Die Losgelöstheit ist der Meister der Unabhängigkeit.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen der Introsistence',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
            },
        },
    },
    determination: {
        [Language.EN]: {
            header: {
                title: 'DETERMINATION',
                mainTitle: 'THE POWER TO KNOW ONE\'S AIMS',
            },
            firstSection: {
                title: 'Determination',
                description: 'The capacity to define one\'s target and not to want anything else. Victory by concentrating all force on the essential.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Determination',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
            },
        },
        [Language.DE]: {
            header: {
                title: 'DETERMINATION',
                mainTitle: 'DIE KRAFT, SEINE ZIELE ZU KENNEN',
            },
            firstSection: {
                title: 'Determination',
                description: 'Die Fähigkeit, sein Ziel zu definieren und nichts Anderes zu wollen. Überlegenheit durch Konzentration aller Kräfte auf das Wesentliche.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen der Determination',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
            },
        },
    },
    connaissance: {
        [Language.EN]: {
            header: {
                title: 'CONNAISSANCE',
                mainTitle: 'THE SELF-DISCOVERY',
            },
            firstSection: {
                title: 'Connaissance',
                description: 'Knowing yourself knows everything. To know oneself brings control of oneself. Control of oneself brings control of everything. The shadow of self-knowledge is self-realization.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Connaissance',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
            },
        },
        [Language.DE]: {
            header: {
                title: 'CONNAISSANCE',
                mainTitle: 'DIE ERKENNTNIS',
            },
            firstSection: {
                title: 'Connaissance',
                description: 'Wer sich selbst kennt, kennt alles. Sich selbst zu kennen, bringt Kontrolle über sich selbst. Die Kontrolle über sich selbst bringt die Kontrolle über alles. Die Selbstverwirklichung folgt der Selbsterkenntnis wie ihr Schatten.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen von Connaissance',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
            },
        },
    },
    essence_desthetique: {
        [Language.EN]: {
            header: {
                title: 'ESSENCE D\'ESTHETIQUE',
                mainTitle: 'BEAUTY THAT NEEDS NO REASON AND NO PURPOSE',
            },
            firstSection: {
                title: 'Essence d\'esthetique',
                description: 'Unstained aesthetics is a power in itself. It does not have to labor or achieve. By its sheer existence, it has already fulfilled its purpose.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Essence d\'Esthétique',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
            },
        },
        [Language.DE]: {
            header: {
                title: 'ESSENCE D\'ESTHETIQUE',
                mainTitle: 'SCHÖNHEIT, DIE WEDER ANLASS NOCH ZWECK BENÖTIGT',
            },
            firstSection: {
                title: 'Essence d\'esthetique',
                description: 'Unverfälschte Ästhetik ist eine Kraft in sich selbst. Sie muss sich nicht anstrengen oder etwas leisten. Durch ihre bloße Existenz hat sie ihren Zweck bereits erfüllt.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen von Essence d\'Esthétique',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
            },
        },
    },
    realization: {
        [Language.EN]: {
            header: {
                title: 'REALIZATION',
                mainTitle: 'THE POWER OF IMPLEMENTATION',
            },
            firstSection: {
                title: 'Realization',
                description: 'The art to stay fully in the reality. The one who has mastered the concentration on the reality, who can keep all thoughts to what is real, can achieve anything.',
            },
            models: {
                singular: 'MODEL',
                plural: 'VARIATIONS',
            },
            variations: 'Variations of Realization',
            specs: {
                mechanicalMovement: 'MECHANICAL MOVEMENT',
                quartzMovement: 'QUARTZ MOVEMENT',
                diameter: 'diameter',
                depth: 'depth',
                waterproofness: 'WATERPROOFNESS',
                watchGlass: 'WATCH GLASS',
                material: 'MATERIAL',
            },
        },
        [Language.DE]: {
            header: {
                title: 'REALIZATION',
                mainTitle: 'DIE KRAFT DER VERWIRKLICHUNG',
            },
            firstSection: {
                title: 'Realization',
                description: 'Die Kunst, ganz in der Realität zu bleiben. Wer die Konzentration auf die Realität gemeistert hat, wer alle Gedanken auf die Realität richten kann, kann alles erreichen.',
            },
            models: {
                singular: 'MODELL',
                plural: 'VARIATIONEN',
            },
            variations: 'Variationen von Realization',
            specs: {
                mechanicalMovement: 'MECHANISCHES WERK',
                quartzMovement: 'QUARZWERK',
                diameter: 'Durchmesser',
                depth: 'Tiefe',
                waterproofness: 'Wasserdichte',
                watchGlass: 'UHRGLAS',
                material: 'MATERIAL',
            },
        },
    },
}; 